import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';

interface ConfirmDeletionProps {
  onConfirm: () => void;
  isLoading: boolean;
  error: string | null;
}

const ConfirmDeletion: React.FC<ConfirmDeletionProps> = ({ onConfirm, isLoading, error }) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [countdown, setCountdown] = useState<number>(5);
  const [showButton, setShowButton] = useState<boolean>(false);

  React.useEffect(() => {
    if (isChecked && countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (isChecked && countdown === 0) {
      setShowButton(true);
    } else if (!isChecked) {
      setShowButton(false);
      setCountdown(5);
    }
  }, [isChecked, countdown]);

  return (
    <div className="form-container">
      <div className="form-header warning">
        <AlertTriangle size={48} className="warning-icon" />
        <h2>Delete Your Account</h2>
        <p>This action is permanent and cannot be undone.</p>
      </div>

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <div className="confirmation-content">
        <div className="warning-box">
          <h3>Warning! Please read carefully:</h3>
          <ul>
            <li>Your account will be permanently deleted</li>
            <li>All your personal data will be removed from our systems</li>
            <li>You will lose access to all services associated with this account</li>
            <li>This action cannot be reversed</li>
          </ul>
        </div>

        <div className="confirmation-checkbox">
          <label className="checkbox-container">
            <input 
              type="checkbox" 
              checked={isChecked}
              onChange={() => setIsChecked(!isChecked)}
              disabled={isLoading}
            />
            <span className="checkmark"></span>
            <span>I understand that this action is permanent and cannot be undone</span>
          </label>
        </div>

        {isChecked && !showButton && (
          <div className="countdown-message">
            Delete button will be available in {countdown} seconds...
          </div>
        )}

        <button 
          className={`delete-button ${showButton ? 'visible' : ''}`}
          onClick={onConfirm}
          disabled={!showButton || isLoading}
        >
          {isLoading ? (
            <span className="loading-spinner"></span>
          ) : (
            'Permanently Delete My Account'
          )}
        </button>
      </div>
    </div>
  );
};

export default ConfirmDeletion;